import apiEmployeeAccess from "@/services/employeeAccess/api/apiEmployeeAccess";

import {
  SET_NOTIFICATIONS,
  SET_MY_TIMES,
  SET_MY_TIME,
  SET_MY_TIME_OFF_BALANCE,
  SET_MY_TIME_OFF,
  SET_TEAM_TIME,
  SET_MY_PAYS,
  SET_MY_TASKS,
  SET_MY_TASK,
  SET_MY_PROFILE,
  SET_MY_BENEFITS,
  SET_MY_CAREER,
  SET_BROWSE_JOBS,
  SET_DASHBOARD_ANNOUNCEMENTS,
  SET_DASHBOARD_MY_TASKS,
  SET_DASHBOARD_UPCOMING_EVENTS,
  SET_USER_GROUPS,
  SET_ASSIGNMENT_HISTORY,
  SET_TIME_OFF_ENTRIES,
  SET_TRANSACTION_DETAILS,
  SET_PUBLISHED_W2,
  SET_ATTRIBUTES,
  SET_DEPENDENTS
} from "@/store/employeeAccess/mutation-types";
import notifications from "@/data/shared/notifications.json";
import dashboardAnnouncements from "@/data/employeeAccess/dashboard/announcements.json";
import dashboardMyTasks from "@/data/employeeAccess/dashboard/myTasks.json";
import dashboardUpcommingEvents from "@/data/employeeAccess/dashboard/upcommingEvents.json";
import myTimes from "@/data/employeeAccess/myTimes.json";
// import myTimeOff from "@/data/employeeAccess/myTimeOff.json";
import myPays from "@/data/employeeAccess/myPays.json";
// import myTasks from "@/data/employeeAccess/myTasks.json";
//import myProfile from "@/data/employeeAccess/myProfile.json";
import myBenefits from "@/data/employeeAccess/myBenefits.json";
import myCareer from "@/data/employeeAccess/myCareer.json";
import browseJobs from "@/data/employeeAccess/browseJobs.json";
import { handleError } from "@/store/shared";
import {
  SET_EMPLOYEES_UNDER,
  SET_MY_TASKS_COUNT,
  SET_REQUEST_TRAIL,
  SET_USER_MANAGEMENT,
  SET_ROLES,
  SET_ROLES_ASSOCIATION,
  SET_ROLE_PERMISSIONS,
  SET_TIME_OFF_REQUEST_CREATED,
  SET_DIRECT_DEPOSITS,
  SET_PAYROLL_ITEMS,
  SET_PAYROLL_ITEM_DETAILS,
  SET_PAYROLL_CHECKS,
  SET_PAYROLL_CHECK_DETAILS,
  SET_PAYROLL_TASK,
  SET_PAYROLL_REGISTERED,
  SET_NEXT_STATUS_LIST_TASK,
  SET_ASSOCIATION_LIST,
  SET_COST_CENTERS,
  SET_USER_ASSIGNMENTS,
  SET_TIME_ENTRY_APPROVAL_REF_ID,
  SET_PAY_CYCLES,
  SET_PAY_CYCLE_DETAIL,
  SET_TASK_PERMISSION,
  SET_REQUESTS
} from "./mutation-types";
const endpoints = require("../../common/endpoints");

const actions = {
  /**
   * set employeeAccess Notifications
   * @param commit
   * @param {String} payload
   * @returns {Promise<void>}
   */
  async setNotifications({ commit }, payload) {
    console.log("setNotifications().payload:", payload);
    commit(SET_NOTIFICATIONS, notifications);
  },
  async setMyTimes({ commit }, payload) {
    // console.log("setMyTimes().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_time_entry, payload)
      .then(response => {
        const data = response?.data;
        if (data?.code >= 200 && data?.code <= 299) {
          commit(SET_MY_TIMES, data?.data);
        } else {
          throw data?.message;
        }
        // console.log("setMyTimes().response.data:", data);
      })
      .catch(error => handleError(error, `Unable to set My Times`));
  },
  async setMyTime({ commit }, payload) {
    return apiEmployeeAccess
      .getTimeSheets()
      .then(response => {
        if (response?.data) {
          if (response?.data?.code >= 200 && response?.data?.code <= 299) {
            const myTime = myTimes.find(el => el.id === payload);
            commit(SET_MY_TIME, myTime);
          } else {
            throw response?.data?.message;
          }
        }
      })
      .catch(error => handleError(error, `Unable to set My Time`));
  },
  async setMyTimeOffBalance({ commit }, payload) {
    // console.log("setMyTimeOffBalance().payload:", payload);

    return apiEmployeeAccess
      .getWithoutPayload(endpoints.accruals, payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_MY_TIME_OFF_BALANCE, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set My Time Off Balance`));
  },
  async setMyTimeOff({ commit }, payload) {
    // console.log("setMyTimeOff().payload:", payload);

    return apiEmployeeAccess
      .getWithoutPayload(endpoints.time_off + payload)
      .then(response => {
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data;
          commit(SET_MY_TIME_OFF, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set My Times Off`));
  },
  async setRequestTrail({ commit }, payload) {
    // console.log("setRequestTrail().payload:", payload);
    return apiEmployeeAccess
      .wfApiGetWithoutPayload(endpoints.request_trail + payload)
      .then(response => {
        // console.log(response);
        var data = response.data.data;
        commit(SET_REQUEST_TRAIL, data);
      })
      .catch(error => handleError(error, `Unable to set Request Trail`));
  },
  async setTeamTime({ commit }, payload) {
    console.log("setTeamTime().payload:", payload);

    return apiEmployeeAccess
      .getWithoutPayload(endpoints.manager_leave_request, payload)
      .then(response => {
        const data = response.data.data;
        console.log("setTeamTime().getWithoutPayload().response.data:", data);
        commit(SET_TEAM_TIME, data);
      })
      .catch(error => handleError(error, `Unable to set Team Time`));
  },
  async setEmployeesUnder({ commit }, payload) {
    console.log("setEmployeesUnder().payload:", payload);

    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_managers_team, payload)
      .then(response => {
        const data = response.data.data;
        console.log(
          "setEmployeesUnder().getWithoutPayload().response.data:",
          data
        );
        commit(SET_EMPLOYEES_UNDER, data);
      })
      .catch(error => handleError(error, `Unable to set Team Time`));
  },
  async setMyPays({ commit }, payload) {
    console.log("setMyPays().payload:", payload);
    commit(SET_MY_PAYS, myPays);
  },
  async setMyTasks({ commit }, payload) {
    // console.log("setMyTasks().payload:", payload);
    return apiEmployeeAccess
      .wfApiPost(endpoints.workflow_tasks_list, payload)
      .then(response => {
        // console.log(response);
        const data = response.data;
        if (data?.code >= 200 && data?.code <= 299) {
          commit(SET_MY_TASKS, data.data);
        } else {
          throw data.message;
        }
      })
      .catch(error => handleError(error, `Unable to set my Tasks`));
  },
  async setMyTasksCount({ commit }, payload) {
    // console.log("setMyTasksCount().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_tasks_count, payload)
      .then(response => {
        const data = response.data.data;
        commit(SET_MY_TASKS_COUNT, data);
      })
      .catch(error => handleError(error, `Unable to set my Tasks Count`));
  },
  async setMyTask({ commit }, payload) {
    // console.log("setMyTask().payload:", payload);
    return apiEmployeeAccess
      .get(endpoints.task_detail, payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          if (response?.data?.data !== null) {
            const data = response.data;
            commit(SET_MY_TASK, data);
          }
        } else {
          throw response.data.message;
        }
      })
      .catch(error => handleError(error, `Unable to set my Task`));
  },
  async setMyProfile({ commit }, payload) {
    // console.log("setMyProfile().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.employee_details, payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response.data.data;
          commit(SET_MY_PROFILE, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set my Profile`));
  },
  async setMyBenefits({ commit }, payload) {
    console.log("setMyBenefits().payload:", payload);
    commit(SET_MY_BENEFITS, myBenefits);
  },
  async setMyCareer({ commit }, payload) {
    console.log("setMyCareer().payload:", payload);
    commit(SET_MY_CAREER, myCareer);
  },
  async setBrowseJobs({ commit }, payload) {
    console.log("setBrowseJobs().payload:", payload);
    commit(SET_BROWSE_JOBS, browseJobs);
  },

  async setDashboardAnnouncements({ commit }, payload) {
    console.log("setDashboardAnnouncements().payload:", payload);

    return apiEmployeeAccess
      .getPersonnelActions()
      .then(response => {
        const data = response.data;
        console.log(
          "setDashboardAnnouncements().getPersonnelActions().response.data:",
          data
        );
        commit(SET_DASHBOARD_ANNOUNCEMENTS, dashboardAnnouncements);
        return data;
      })
      .catch(error =>
        handleError(error, `Unable to set Dashboard Announcements`)
      );
  },
  async setDashboardMyTasks({ commit }, payload) {
    console.log("setDashboardAnnouncements().payload:", payload);

    return apiEmployeeAccess
      .getPersonnelActions()
      .then(response => {
        const data = response.data;
        console.log("setDashboardMyTasks().payload:", payload);
        commit(SET_DASHBOARD_MY_TASKS, dashboardMyTasks);
        return data;
      })
      .catch(error => handleError(error, `Unable to set Dashboard My Tasks`));
  },
  async setDashboardUpcomingEvents({ commit }, payload) {
    console.log("setDashboardUpcomingEvents().payload:", payload);

    return apiEmployeeAccess
      .getPersonnelActions()
      .then(response => {
        const data = response.data;
        console.log("setDashboardUpcomingEvents().payload:", payload);
        commit(SET_DASHBOARD_UPCOMING_EVENTS, dashboardUpcommingEvents);
        return data;
      })
      .catch(error =>
        handleError(error, `Unable to set Dashboard Upcoming Events`)
      );
  },
  async setUserManagement({ commit }, payload) {
    console.log("setUserManagement().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_all_employee_association, payload)
      .then(response => {
        var data = response.data.data;
        commit(SET_USER_MANAGEMENT, data);
      })
      .catch(error => handleError(error, `Unable to set User Management`));
  },
  async setRoles({ commit }, payload) {
    console.log("setRoles().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_roles, payload)
      .then(response => {
        var data = response.data.data;
        commit(SET_ROLES, data);
      })
      .catch(error => handleError(error, `Unable to set Roles`));
  },
  async setRolesAssociation({ commit }, payload) {
    console.log("setRolesAssociation().payload:", payload);
    return apiEmployeeAccess
      .get(endpoints.get_user_role_assignment, payload)
      .then(response => {
        var data = response.data;
        commit(SET_ROLES_ASSOCIATION, data);
      })
      .catch(error => handleError(error, `Unable to set Roles Association`));
  },
  async setRolePermissions({ commit }, payload) {
    console.log("setRolePermissions().payload:", payload);
    return apiEmployeeAccess
      .get(endpoints.get_user_role_permissions, payload)
      .then(response => {
        let data = response.data;
        commit(SET_ROLE_PERMISSIONS, data);
      })
      .catch(error => handleError(error, `Unable to set Role Permissions`));
  },
  async setTimeOffRequestCreated({ commit }, payload) {
    commit(SET_TIME_OFF_REQUEST_CREATED, payload);
  },
  async setTimeEntryApprovalRefId({ commit }, payload) {
    // console.log("setTimeEntryApprovalRefId().payload:", payload);
    commit(SET_TIME_ENTRY_APPROVAL_REF_ID, payload);
  },
  async setDirectDeposits({ commit }, payload) {
    // console.log("setDirectDeposits().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_direct_deposits, payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response.data.data;
          commit(SET_DIRECT_DEPOSITS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Direct Deposits`));
  },
  async setPayrollItems({ commit }, payload) {
    // console.log("setPayrollItems().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_payroll_items + payload)
      .then(response => {
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_PAYROLL_ITEMS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Payroll Items`));
  },
  async setPayrollItemDetails({ commit }, payload) {
    // console.log("setPayrollItemDetails().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_payroll_item_details + payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_PAYROLL_ITEM_DETAILS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Payroll Item Details`));
  },
  async setPayrollChecks({ commit }, payload) {
    // console.log("setPayrollChecks().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_payroll_checks, payload)
      .then(response => {
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          // console.log(data);
          commit(SET_PAYROLL_CHECKS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Payroll Checks`));
  },
  async setPayrollCheckDetails({ commit }, payload) {
    // console.log("setPayrollCheckDetails().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_payroll_check_details + payload)
      .then(response => {
        // console.log(response);
        const data = response.data.data;
        commit(SET_PAYROLL_CHECK_DETAILS, data);
      })
      .catch(error =>
        handleError(error, `Unable to set Payroll Check Details`)
      );
  },
  /**
   * Action method to set Payroll Task
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setPayrollTask({ commit }, payload) {
    // console.log("setPayrollTask().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_payroll_task, payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_PAYROLL_TASK, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Payroll Tasks`));
  },
  /**
   * Action method to set Payroll Registered
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setPayrollRegistered({ commit }, payload) {
    // console.log("setPayrollRegistered().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_verify_payroll_user, payload)
      .then(response => {
        const data = response.data.data;
        commit(SET_PAYROLL_REGISTERED, data);
      })
      .catch(error => handleError(error, `Unable to set Payroll Registered`));
  },
  /**
   * Action method to set Next Status List Task
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setNextStatusListTask({ commit }, payload) {
    // console.log("setNextStatusListTask().payload:", payload);
    return apiEmployeeAccess
      .wfApiGetWithoutPayload(endpoints.workflow_next_status_list + payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_NEXT_STATUS_LIST_TASK, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error =>
        handleError(error, `Unable to set Next Status List Task`)
      );
  },
  /**
   * Action method to set Association List
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setAssociationList({ commit }, payload) {
    // console.log("setAssociationList().payload:", payload);
    return apiEmployeeAccess
      .cityCenterApiGetWithoutPayload(endpoints.get_association_list + payload)
      .then(response => {
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_ASSOCIATION_LIST, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Association List`));
  },
  /**
   * Action method to set cost centers
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setCostCenters({ commit }, payload) {
    console.log("setCostCenters().payload:", payload);
    return apiEmployeeAccess
      .cityCenterApiGetWithoutPayload(endpoints.get_cost_centers + payload)
      .then(response => {
        console.log(response);
        var data = response?.data?.data;
        commit(SET_COST_CENTERS, data);
      })
      .catch(error => handleError(error, `Unable to set Cost Centers`));
  },
  /**
   * Action method to set user assignments
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setUserAssignments({ commit }, payload) {
    // console.log("setUserAssignments().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.user_assignments, payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_USER_ASSIGNMENTS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set User Assignments`));
  },
  /**
   * Action method to set pay cycles
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setPayCycles({ commit }, payload) {
    // console.log("setPayCycles().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.pay_cycles + payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_PAY_CYCLES, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Pay Cycles`));
  },
  async setPayCycleDetail({ commit }, payload) {
    // console.log("setPayCycleDetail().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.pay_cycle_detail + payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data;
          commit(SET_PAY_CYCLE_DETAIL, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Pay Cycle Detail`));
  },
  async setTaskPermission({ commit }, payload) {
    // console.log("setTaskPermission().payload:", payload);
    return apiEmployeeAccess
      .wfApiGetWithoutPayload(endpoints.task_permission + payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response.data.data;
          commit(SET_TASK_PERMISSION, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Task Permission`));
  },
  async setUserGroups({ commit }, payload) {
    // console.log("setUserGroups().payload:", payload);
    return apiEmployeeAccess
      .cityCenterApiGetWithoutPayload(endpoints.user_groups, payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_USER_GROUPS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set User Groups`));
  },
  /**
   * Action method to set assignment history
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setAssignmentHistory({ commit }, payload) {
    // console.log("setAssignmentHistory().payload:", payload);
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.assignment_history, payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_ASSIGNMENT_HISTORY, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Assignment History`));
  },
  /**
   * Action method to set time off entries
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setTimeOffEntries({ commit }, payload) {
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.time_off_details + payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_TIME_OFF_ENTRIES, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Time Off Entries`));
  },
  /**
   * Action method to set transaction details
   * @param commit
   * @param payload
   * @return {Promise<AxiosResponse<any> | *>}
   */
  async setTransactionDetails({ commit }, payload) {
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.transaction_details + payload)
      .then(response => {
        // console.log(response);
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_TRANSACTION_DETAILS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Transaction Details`));
  },
  async setPublishedW2({ commit }, payload) {
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_published_w2 + payload)
      .then(response => {
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_PUBLISHED_W2, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Published W2`));
  },
  async setAttributes({ commit }, payload) {
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_attributes, payload)
      .then(response => {
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_ATTRIBUTES, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Attributes`));
  },
  async setDependents({ commit }, payload) {
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_dependents, payload)
      .then(response => {
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_DEPENDENTS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Dependents`));
  },
  async setRequests({ commit }, payload) {
    return apiEmployeeAccess
      .getWithoutPayload(endpoints.get_requests, payload)
      .then(response => {
        if (response?.data?.code >= 200 && response?.data?.code <= 299) {
          const data = response?.data?.data;
          commit(SET_REQUESTS, data);
        } else {
          throw response?.data?.message;
        }
      })
      .catch(error => handleError(error, `Unable to set Requests`));
  }
};

export default actions;
